import React from 'react';
import { Box, Flex, Text, Stat, StatNumber, StatHelpText, StatArrow, Icon } from '@chakra-ui/react';

const formatValue = (value, format) => {
    if (value === null || value === undefined) return '—';
    if (format === 'currency') {
        return Number(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }
    if (format === 'number') {
        return Number(value).toLocaleString('pt-BR');
    }
    return value;
};

const StatusCard = ({ title, value, change, isPositive, icon, colorScheme = 'green', format }) => {
    const colors = {
        green: 'secondary',
        red: 'red.400',
        yellow: 'yellow.400',
        blue: 'blue.400',
    };

    return (
        <Stat
            p={4}
            bg="surface"
            borderRadius="lg"
            border="1px solid"
            borderColor="gray.800"
            _hover={{ borderColor: colors[colorScheme] }}
            transition="border-color 0.2s ease"
        >
            <Flex
                alignItems="center"
                justifyContent="space-between"
                wrap="wrap"
                gap={2}
            >
                <Box
                    flex="1"
                    minW="160px"
                >
                    <Text fontSize="sm" color="gray.400" noOfLines={1}>
                        {title}
                    </Text>

                    <StatNumber fontSize="2xl" color={colors[colorScheme]} noOfLines={1}>
                        {formatValue(value, format)}
                    </StatNumber>
                    
                    <StatHelpText minH="21px">
                        {change && (
                            <Flex as="span">
                                <StatArrow type={isPositive ? 'increase' : 'decrease'} />
                                {change}
                            </Flex>
                        )}
                    </StatHelpText>
                </Box>
                
                <Icon as={icon} w={8} h={8} color={colors[colorScheme]} opacity={0.8} />
            </Flex>
        </Stat>
    );
};

export default StatusCard;